// components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "universal-cookie";

const ProtectedRoute = ({ children }) => {
  const cookies = new Cookies();
  const tieneRegional =
    cookies.get("regional") && cookies.get("regional") !== "";

  return tieneRegional ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
